export default __webpack_public_path__ + "0f88823ac22bc62f9472f4361a39a638.png";